// Out of Stock Form JavaScript
class OutOfStockForm {
  constructor() {
    this.forms = document.querySelectorAll('.out-of-stock-form');
    this.init();
  }

  init() {
    if (this.forms.length === 0) return;
    
    this.setupEventListeners();
    
    // Initialize form visibility based on current state
    // Use multiple timeouts to catch different loading states
    setTimeout(() => this.updateFormsOnVariantChange(), 100);
    setTimeout(() => this.updateFormsOnVariantChange(), 500);
    setTimeout(() => this.updateFormsOnVariantChange(), 1000);
  }

  setupEventListeners() {
    // Global click listener for toggle and cancel buttons
    document.addEventListener('click', (event) => {
      if (event.target.matches('.out-of-stock-toggle')) {
        event.preventDefault();
        this.toggleForm(event.target);
      } else if (event.target.matches('.out-of-stock-cancel')) {
        event.preventDefault();
        this.hideForm(event.target);
      }
    });

    // Listen for variant changes
    document.addEventListener('change', (event) => {
      if (event.target.matches('input[name="id"], select[name="id"], input[type="radio"][name*="option"], select[name*="option"]')) {
        setTimeout(() => {
          this.updateFormsOnVariantChange();
        }, 100);
      }
    });

    // Listen for custom variant change events that some themes might fire
    document.addEventListener('variant:change', () => {
      setTimeout(() => {
        this.updateFormsOnVariantChange();
      }, 100);
    });
  }

  toggleForm(button) {
    const form = button.closest('.out-of-stock-form');
    if (!form) return;

    const trigger = form.querySelector('.out-of-stock-trigger');
    const fields = form.querySelector('.out-of-stock-form-fields');
    
    if (!trigger || !fields) return;

    const isVisible = fields.style.display !== 'none';
    
    if (isVisible) {
      // Hide form
      fields.style.display = 'none';
      trigger.style.display = 'block';
    } else {
      // Show form
      fields.style.display = 'block';
      trigger.style.display = 'none';
      
      // Focus on first input
      const firstInput = fields.querySelector('input[type="email"], input[type="text"], textarea');
      if (firstInput) {
        setTimeout(() => firstInput.focus(), 100);
      }
    }
  }

  hideForm(button) {
    const form = button.closest('.out-of-stock-form');
    if (!form) return;

    const trigger = form.querySelector('.out-of-stock-trigger');
    const fields = form.querySelector('.out-of-stock-form-fields');
    
    if (trigger && fields) {
      fields.style.display = 'none';
      trigger.style.display = 'block';
    }
  }

  updateFormsOnVariantChange() {
    // Get current variant
    const currentVariant = this.getCurrentVariant();
    
    this.forms.forEach(form => {
      this.updateFormVisibility(form, currentVariant);
      this.updateFormContent(form, currentVariant);
    });
  }

  getCurrentVariant() {
    // Get product data from multiple sources
    const productData = this.getProductData();
    if (!productData) {
      console.log('No product data found');
      return null;
    }

    console.log('Product data found:', productData);

    // Method 1: Try to get variant from product form
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const variantInput = productForm.querySelector('input[name="id"]:checked, select[name="id"], input[name="id"]');
      if (variantInput && variantInput.value) {
        const variantId = parseInt(variantInput.value);
        const variant = productData.variants.find(v => v.id === variantId);
        if (variant) {
          console.log('Found variant from form:', variant);
          return variant;
        }
      }
    }

    // Method 2: Try to get from option selectors
    const optionSelectors = document.querySelectorAll('input[type="radio"]:checked[name*="option"], select[name*="option"]');
    if (optionSelectors.length > 0) {
      const selectedOptions = [];
      optionSelectors.forEach(selector => {
        selectedOptions.push(selector.value);
      });
      
      console.log('Selected options:', selectedOptions);
      
      // Find variant matching selected options
      const matchingVariant = productData.variants.find(variant => {
        return variant.options.every((option, index) => {
          return selectedOptions[index] === option;
        });
      });
      
      if (matchingVariant) {
        console.log('Found variant from options:', matchingVariant);
        return matchingVariant;
      }
    }

    // Method 3: For single variant products, return the only variant
    if (productData.variants.length === 1) {
      console.log('Single variant product:', productData.variants[0]);
      return productData.variants[0];
    }

    // Method 4: Return first variant as fallback
    if (productData.variants.length > 0) {
      console.log('Fallback to first variant:', productData.variants[0]);
      return productData.variants[0];
    }

    return null;
  }

  getProductData() {
    // Method 1: Check for window.product
    if (typeof window.product !== 'undefined' && window.product && window.product.variants) {
      return window.product;
    }

    // Method 2: Check for other common product objects
    if (typeof window.productData !== 'undefined' && window.productData) {
      return window.productData;
    }

    // Method 3: Look for JSON in script tags
    const productScripts = document.querySelectorAll('script[type="application/json"]');
    for (let script of productScripts) {
      try {
        const data = JSON.parse(script.textContent);
        if (data.variants && Array.isArray(data.variants)) {
          return data;
        }
        if (data.product && data.product.variants) {
          return data.product;
        }
      } catch (e) {
        // Continue to next script
      }
    }

    // Method 4: Look for product data in meta tags or data attributes
    const productMeta = document.querySelector('meta[name="product"], [data-product-json]');
    if (productMeta) {
      try {
        const content = productMeta.getAttribute('content') || productMeta.getAttribute('data-product-json');
        const data = JSON.parse(content);
        if (data.variants) {
          return data;
        }
      } catch (e) {
        // Continue
      }
    }

    // Method 5: Extract from theme's global objects
    if (typeof window.theme !== 'undefined' && window.theme.product) {
      return window.theme.product;
    }

    console.log('No product data source found');
    return null;
  }

  updateFormVisibility(form, variant) {
    const productData = this.getProductData();
    
    // Debug logging
    console.log('Out of Stock Form Debug:', {
      variant: variant,
      available: variant ? variant.available : 'no variant',
      productData: productData ? 'found' : 'not found',
      productVariantsCount: productData ? productData.variants.length : 'no product data'
    });
    
    let shouldShow = false;
    
    if (!variant) {
      // If no variant detected, use fallback methods
      shouldShow = this.fallbackOutOfStockDetection();
    } else {
      // Show form only if variant is NOT available
      shouldShow = !variant.available;
    }
    
    console.log('Should show out of stock form:', shouldShow);
    
    if (shouldShow) {
      form.style.display = 'block';
      form.classList.remove('hidden');
    } else {
      form.style.display = 'none';
      form.classList.add('hidden');
      
      // Reset form state when hiding
      const trigger = form.querySelector('.out-of-stock-trigger');
      const fields = form.querySelector('.out-of-stock-form-fields');
      
      if (trigger && fields) {
        trigger.style.display = 'block';
        fields.style.display = 'none';
      }
    }
  }

  fallbackOutOfStockDetection() {
    console.log('Using fallback out of stock detection');
    
    // Method 1: Check add to cart button state
    const addToCartButton = document.querySelector('button[name="add"], input[name="add"], button[type="submit"][class*="add"], .product-form button[type="submit"]');
    if (addToCartButton) {
      const buttonText = addToCartButton.textContent.toLowerCase();
      const isDisabled = addToCartButton.disabled;
      const isSoldOut = buttonText.includes('sold out') || buttonText.includes('unavailable') || buttonText.includes('out of stock');
      
      console.log('Button check:', { buttonText, isDisabled, isSoldOut });
      
      if (isDisabled || isSoldOut) {
        return true;
      }
    }
    
    // Method 2: Check for sold out text on page
    const soldOutElements = document.querySelectorAll('.sold-out, .out-of-stock, .unavailable, [class*="sold"], [class*="stock"]');
    for (let element of soldOutElements) {
      if (element.style.display !== 'none' && element.textContent.toLowerCase().includes('sold out')) {
        console.log('Found sold out element:', element);
        return true;
      }
    }
    
    // Method 3: Check inventory status elements
    const inventoryElements = document.querySelectorAll('.product__inventory, .inventory-status, [class*="inventory"]');
    for (let element of inventoryElements) {
      const text = element.textContent.toLowerCase();
      if (text.includes('out of stock') || text.includes('sold out')) {
        console.log('Found inventory status indicating out of stock:', element);
        return true;
      }
    }
    
    console.log('Fallback detection: product appears to be in stock');
    return false;
  }

  updateFormContent(form, variant) {
    if (!variant) return;

    // Update hidden product info
    const bodyInput = form.querySelector('input[name="contact[body]"]');
    if (bodyInput && window.product) {
      const productTitle = window.product.title;
      const variantTitle = variant.title !== 'Default Title' ? variant.title : '';
      const fullTitle = variantTitle ? `${productTitle} - ${variantTitle}` : productTitle;
      
      bodyInput.value = `Please notify me when "${fullTitle}" becomes available.`;
    }

    // Update variant-specific hidden fields if needed
    const existingVariantInput = form.querySelector('input[name="contact[variant_id]"]');
    if (existingVariantInput) {
      existingVariantInput.value = variant.id;
    } else {
      // Create hidden variant input
      const variantInput = document.createElement('input');
      variantInput.type = 'hidden';
      variantInput.name = 'contact[variant_id]';
      variantInput.value = variant.id;
      form.querySelector('form').appendChild(variantInput);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new OutOfStockForm();
  });
} else {
  new OutOfStockForm();
}

// Re-initialize on Shopify section loads (for theme editor)
document.addEventListener('shopify:section:load', () => {
  new OutOfStockForm();
});

// Global function for backwards compatibility
window.toggleOutOfStockForm = function() {
  const button = event.target;
  const form = button.closest('.out-of-stock-form');
  if (form) {
    const instance = new OutOfStockForm();
    instance.toggleForm(button);
  }
}; 